<template>
    <RemoveRow></RemoveRow>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const RemoveRow = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/RemoveRow.vue"
    )
);

export default {
    name: "Project_HelpRemoveRow", //The name you are in should not equal the name of the component you are importing.
    components: { RemoveRow, AuthLayout },
};
</script>
